import { t } from '@lingui/core/macro';
import { Paper, type PaperProps, Typography } from '@mui/material';
import type { FC } from 'react';

const SearchNotFound: FC<PaperProps> = ({ ...other }) => {
  return (
    <Paper {...other}>
      <Typography gutterBottom align="center" variant="subtitle1">
        {t`Aucun résultat`}
      </Typography>
      <Typography align="center">
        {t`Aucun résultat trouvé pour votre recherche. Essayez de vérifier les fautes de frappe ou d’utiliser des mots complets.`}
      </Typography>
    </Paper>
  );
};

export default SearchNotFound;
